// Sports page SEO patterns and slug map
// Keep in sync with libs/content/src/lib/seo/en.json
// Sports page title/description patterns - {sport} and {brand} are substituted at build time
export const sportSeoPatterns = {
    title: '{sport} Betting | Bet on Sports Online | {brand}',
    description: '{sport} Sports Betting at {brand}. Competitive odds, live betting, and fast crypto payouts on all {sport} events.'
};
// slug → display name map for all sports pages
// Must stay in sync with defaultSportsMap in seo.ts
export const sportsSlugMap = {
    // Sports
    'soccer-1': 'Football',
    'basketball-2': 'Basketball',
    'baseball-3': 'Baseball',
    'ice-hockey-4': 'Ice Hockey',
    'tennis-5': 'Tennis',
    'handball-6': 'Handball',
    'floorball-7': 'Floorball',
    'golf-9': 'Golf',
    'boxing-10': 'Boxing',
    'rugby-union-12': 'Rugby Union',
    'australian-football-13': 'Australian Football',
    'bandy-15': 'Bandy',
    'american-football-16': 'American Football',
    'cycling-17': 'Cycling',
    'snooker-19': 'Snooker',
    'table-tennis-20': 'Table Tennis',
    'cricket-21': 'Cricket',
    'darts-22': 'Darts',
    'volleyball-23': 'Volleyball',
    'field-hockey-24': 'Field Hockey',
    'water-polo-26': 'Water Polo',
    'curling-28': 'Curling',
    'futsal-29': 'Futsal',
    'olympics-30': 'Olympics',
    'badminton-31': 'Badminton',
    'chess-33': 'Chess',
    'squash-37': 'Squash',
    'lacrosse-39': 'Lacrosse',
    'formula-1-40': 'Formula 1',
    'alpine-skiing-43': 'Alpine Skiing',
    'biathlon-44': 'Biathlon',
    'bobsleigh-45': 'Bobsleigh',
    'cross-country-46': 'Cross Country',
    'nordic-combined-47': 'Nordic Combined',
    'ski-jumping-48': 'Ski Jumping',
    'snowboard-49': 'Snowboard',
    'speed-skating-50': 'Speed Skating',
    'luge-51': 'Luge',
    'rugby-league-59': 'Rugby League',
    'nascar-70': 'Nascar',
    'padel-tennis-71': 'Padel Tennis',
    'sailing-81': 'Sailing',
    'sumo-99': 'Sumo',
    'rally-101': 'Rally',
    'figure-skating-102': 'Figure Skating',
    'freestyle-skiing-103': 'Freestyle Skiing',
    'skeleton-104': 'Skeleton',
    'short-track-105': 'Short Track',
    'mixed-martial-arts-117': 'MMA',
    'indy-racing-129': 'Indy Racing',
    'speedway-131': 'Speedway',
    'kabaddi-138': 'Kabaddi',
    'basketball-3x3-155': 'Basketball 3x3',
    'touring-car-racing-188': 'Touring Car Racing',
    'formula-2-189': 'Formula 2',
    'motorcycle-racing-190': 'Motorcycle Racing',
    'teqball-210': 'Teqball',
    'pickleball-242': 'Pickleball',
    'footvolley-244': 'Footvolley',
    'pro-wrestling-250': 'Pro Wrestling',
    'ski-mountaineering-252': 'Ski Mountaineering',
    // Esports
    'counter-strike-109': 'Counter-Strike',
    'league-of-legends-110': 'League of Legends',
    'dota-2-111': 'Dota 2',
    'world-of-tanks-115': 'World of Tanks',
    'call-of-duty-118': 'Call of Duty',
    'crossfire-123': 'Crossfire',
    'rainbow-six-125': 'Rainbow Six',
    'king-of-glory-134': 'King of Glory',
    'fc-26-137': 'FC 26',
    'pubg-140': 'PUBG',
    'nba-2k26-153': 'NBA 2K26',
    'arena-of-valor-158': 'Arena of Valor',
    'teamfight-tactics-174': 'Teamfight Tactics',
    'valorant-194': 'Valorant',
    'mobile-legends-201': 'Mobile Legends',
    'cricket-24-238': 'Cricket 24',
    'fifa-300': 'FIFA',
    // Virtual sports
    'esoccer-300': 'eSoccer',
    'ebasketball-302': 'eBasketball',
    'etennis-303': 'eTennis',
    'efighting-304': 'eFighting',
    'ecricket-305': 'eCricket',
    'esoccer-penalty-307': 'eSoccer Penalty',
    'esoccer-volta-309': 'eSoccer Volta',
    'ehorse-racing-315': 'eHorse Racing',
    'ebasketball-blitz-316': 'eBasketball Blitz',
    'ecricket-x-battle-bats-322': 'eCricket X-Battle Bats',
    'evaquejada-323': 'eVaquejada',
    'esoccer-x-battle-fc-324': 'eSoccer X-Battle FC',
    'blitz-basketball-316': 'NBA 2K'
};
